import * as UnitDivide from "../unit-divide";
import { KiloWatt, Watt } from "./power";
import { CubicMeterPerSecond, CubicFeetPerMinute } from "./volume-flow";
// Specific Fan Power
export var KiloWattPerCubicMeterPerSecond = UnitDivide.powerByVolumeFlow("KiloWattPerCubicMeterPerSecond", KiloWatt, CubicMeterPerSecond);
export var WattPerCubicMeterPerSecond = UnitDivide.powerByVolumeFlow("WattPerCubicMeterPerSecond", Watt, CubicMeterPerSecond);
export var KiloWattPerCubicFootPerMinute = UnitDivide.powerByVolumeFlow("KiloWattPerCubicFootPerMinute", KiloWatt, CubicFeetPerMinute);
//# sourceMappingURL=specific-fan-power.js.map